import { CountryData } from './types';

export const countryData: CountryData = {
  AD: {
    placeholder: '___ ___',
    mask: '999 999',
    code: 376
  },
  AE: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 971
  },
  AF: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 93
  },
  AG: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  AI: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  AL: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 355
  },
  AM: {
    placeholder: '__ ______',
    mask: '99 999999',
    code: 374
  },
  AO: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 244
  },
  AR: {
    placeholder: '__ ____-____',
    mask: '99 9999-9999',
    code: 54
  },
  AS: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  AT: {
    placeholder: '_ _________',
    mask: '9 999999999',
    code: 43
  },
  AU: {
    placeholder: '_ ____ ____',
    mask: '9 9999 9999',
    code: 61
  },
  AW: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 297
  },
  AX: {
    placeholder: '__ _______',
    mask: '99 9999999',
    code: 358
  },
  AZ: {
    placeholder: '__ ___ __ __',
    mask: '99 999 99 99',
    code: 994
  },
  BA: {
    placeholder: '__ ___-___',
    mask: '99 999-999',
    code: 387
  },
  BB: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  BD: {
    placeholder: '____-______',
    mask: '9999-999999',
    code: 880
  },
  BE: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 32
  },
  BF: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 226
  },
  BG: {
    placeholder: '_ ___ ___',
    mask: '9 999 999',
    code: 359
  },
  BH: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 973
  },
  BI: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 257
  },
  BJ: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 229
  },
  BL: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 590
  },
  BM: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  BN: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 673
  },
  BO: {
    placeholder: '_ _______',
    mask: '9 9999999',
    code: 591
  },
  BQ: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 599
  },
  BR: {
    placeholder: '(__) _____-____',
    mask: '(99) 99999-9999',
    code: 55
  },
  BS: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  BT: {
    placeholder: '_ ___ ___',
    mask: '9 999 999',
    code: 975
  },
  BW: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 267
  },
  BY: {
    placeholder: '___ __-__-__',
    mask: '999 99-99-99',
    code: 375
  },
  BZ: {
    placeholder: '___-____',
    mask: '999-9999',
    code: 501
  },
  CA: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  CC: {
    placeholder: '_ ____ ____',
    mask: '9 9999 9999',
    code: 61
  },
  CD: {
    placeholder: '__ _____',
    mask: '99 99999',
    code: 243
  },
  CF: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 236
  },
  CG: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 242
  },
  CH: {
    placeholder: '__ ___ __ __',
    mask: '99 999 99 99',
    code: 41
  },
  CI: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 225
  },
  CK: {
    placeholder: '__ ___',
    mask: '99 999',
    code: 682
  },
  CL: {
    placeholder: '_ ____ ____',
    mask: '9 9999 9999',
    code: 56
  },
  CM: {
    placeholder: '_ __ __ __ __',
    mask: '9 99 99 99 99',
    code: 237
  },
  CN: {
    placeholder: '___ ____ ____',
    mask: '999 9999 9999',
    code: 86
  },
  CO: {
    placeholder: '___ _______',
    mask: '999 9999999',
    code: 57
  },
  CR: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 506
  },
  CU: {
    placeholder: '_ _______',
    mask: '9 9999999',
    code: 53
  },
  CV: {
    placeholder: '___ __ __',
    mask: '999 99 99',
    code: 238
  },
  CW: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 599
  },
  CX: {
    placeholder: '_ ____ ____',
    mask: '9 9999 9999',
    code: 61
  },
  CY: {
    placeholder: '__ ______',
    mask: '99 999999',
    code: 357
  },
  CZ: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 420
  },
  DE: {
    placeholder: '__ ______',
    mask: '99 999999',
    code: 49
  },
  DJ: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 253
  },
  DK: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 45
  },
  DM: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  DO: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  DZ: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 213
  },
  EC: {
    placeholder: '_-___-____',
    mask: '9-999-9999',
    code: 593
  },
  EE: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 372
  },
  EG: {
    placeholder: '_ ________',
    mask: '9 99999999',
    code: 20
  },
  EH: {
    placeholder: '____-_____',
    mask: '9999-99999',
    code: 212
  },
  ER: {
    placeholder: '_ ___ ___',
    mask: '9 999 999',
    code: 291
  },
  ES: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 34
  },
  ET: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 251
  },
  FI: {
    placeholder: '__ _______',
    mask: '99 9999999',
    code: 358
  },
  FJ: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 679
  },
  FK: {
    placeholder: '_____',
    mask: '99999',
    code: 500
  },
  FM: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 691
  },
  FO: {
    placeholder: '______',
    mask: '999999',
    code: 298
  },
  FR: {
    placeholder: '_ __ __ __ __',
    mask: '9 99 99 99 99',
    code: 33
  },
  GA: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 241
  },
  GB: {
    placeholder: '___ ___ ____',
    mask: '999 999 9999',
    code: 44
  },
  GD: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  GE: {
    placeholder: '__ ___ __ __',
    mask: '99 999 99 99',
    code: 995
  },
  GF: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 594
  },
  GG: {
    placeholder: '____ ______',
    mask: '9999 999999',
    code: 44
  },
  GH: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 233
  },
  GI: {
    placeholder: '___ _____',
    mask: '999 99999',
    code: 350
  },
  GL: {
    placeholder: '__ __ __',
    mask: '99 99 99',
    code: 299
  },
  GM: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 220
  },
  GN: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 224
  },
  GP: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 590
  },
  GQ: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 240
  },
  GR: {
    placeholder: '__ ____ ____',
    mask: '99 9999 9999',
    code: 30
  },
  GT: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 502
  },
  GU: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  GW: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 245
  },
  GY: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 592
  },
  HK: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 852
  },
  HN: {
    placeholder: '____-____',
    mask: '9999-9999',
    code: 504
  },
  HR: {
    placeholder: '_ ____ ___',
    mask: '9 9999 999',
    code: 385
  },
  HT: {
    placeholder: '__ __ ____',
    mask: '99 99 9999',
    code: 509
  },
  HU: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 36
  },
  ID: {
    placeholder: '___ ____ ____',
    mask: '999 9999 9999',
    code: 62,
    minDigits: 9
  },
  IE: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 353,
    minDigits: 7
  },
  IL: {
    placeholder: '_-___-____',
    mask: '9-999-9999',
    code: 972
  },
  IM: {
    placeholder: '____ ______',
    mask: '9999 999999',
    code: 44
  },
  IN: {
    placeholder: '_____ _____',
    mask: '99999 99999',
    code: 91
  },
  IO: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 246
  },
  IQ: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 964
  },
  IR: {
    placeholder: '__ ____ ____',
    mask: '99 9999 9999',
    code: 98
  },
  IS: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 354
  },
  IT: {
    placeholder: '__ ____ ____',
    mask: '99 9999 9999',
    code: 39
  },
  JE: {
    placeholder: '____ ______',
    mask: '9999 999999',
    code: 44
  },
  JM: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  JO: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 962
  },
  JP: {
    placeholder: '_-____-____',
    mask: '9-9999-9999',
    code: 81
  },
  KE: {
    placeholder: '__ _______',
    mask: '99 9999999',
    code: 254
  },
  KG: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 996
  },
  KH: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 855
  },
  KI: {
    placeholder: '_____',
    mask: '99999',
    code: 686
  },
  KM: {
    placeholder: '___ __ __',
    mask: '999 99 99',
    code: 269
  },
  KN: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  KP: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 850
  },
  KR: {
    placeholder: '_-___-____',
    mask: '9-999-9999',
    code: 82
  },
  KW: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 965
  },
  KY: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  KZ: {
    placeholder: '_____ _ __ __',
    mask: '99999 9 99 99',
    code: 7
  },
  LA: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 856
  },
  LB: {
    placeholder: '_ ___ ___',
    mask: '9 999 999',
    code: 961
  },
  LC: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  LI: {
    placeholder: '___ __ __',
    mask: '999 99 99',
    code: 423
  },
  LK: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 94
  },
  LR: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 231
  },
  LS: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 266
  },
  LT: {
    placeholder: '___ _____',
    mask: '999 99999',
    code: 370
  },
  LU: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 352
  },
  LV: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 371
  },
  LY: {
    placeholder: '__-_______',
    mask: '99-9999999',
    code: 218
  },
  MA: {
    placeholder: '___-______',
    mask: '999-999999',
    code: 212
  },
  MC: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 377
  },
  MD: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 373
  },
  ME: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 382
  },
  MF: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 590
  },
  MG: {
    placeholder: '__ __ ___ __',
    mask: '99 99 999 99',
    code: 261
  },
  MH: {
    placeholder: '___-____',
    mask: '999-9999',
    code: 692
  },
  MK: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 389
  },
  ML: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 223
  },
  MM: {
    placeholder: '_ ___ ___',
    mask: '9 999 999',
    code: 95
  },
  MN: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 976
  },
  MO: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 853
  },
  MP: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  MQ: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 596
  },
  MR: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 222
  },
  MS: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  MT: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 356
  },
  MU: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 230
  },
  MV: {
    placeholder: '___-____',
    mask: '999-9999',
    code: 960
  },
  MW: {
    placeholder: '_ ___ ___',
    mask: '9 999 999',
    code: 265
  },
  MX: {
    placeholder: '___ ___ ____',
    mask: '999 999 9999',
    code: 52
  },
  MY: {
    placeholder: '__-____ ____',
    mask: '99-9999 9999',
    code: 60,
    minDigits: 9
  },
  MZ: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 258
  },
  NA: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 264
  },
  NC: {
    placeholder: '__.__.__',
    mask: '99.99.99',
    code: 687
  },
  NE: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 227
  },
  NF: {
    placeholder: '__ ____',
    mask: '99 9999',
    code: 672
  },
  NG: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 234
  },
  NI: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 505
  },
  NL: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 31
  },
  NO: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 47
  },
  NP: {
    placeholder: '_-_______',
    mask: '9-9999999',
    code: 977
  },
  NR: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 674
  },
  NU: {
    placeholder: '____',
    mask: '9999',
    code: 683
  },
  NZ: {
    placeholder: '_-___ ____',
    mask: '9-999 9999',
    code: 64
  },
  OM: {
    placeholder: '__ ______',
    mask: '99 999999',
    code: 968
  },
  PA: {
    placeholder: '___-____',
    mask: '999-9999',
    code: 507
  },
  PE: {
    placeholder: '_ _______',
    mask: '9 9999999',
    code: 51
  },
  PF: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 689
  },
  PG: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 675
  },
  PH: {
    placeholder: '___ ___ ____',
    mask: '999 999 9999',
    code: 63
  },
  PK: {
    placeholder: '__ ________',
    mask: '99 99999999',
    code: 92
  },
  PL: {
    placeholder: '__ ___ __ __',
    mask: '99 999 99 99',
    code: 48
  },
  PM: {
    placeholder: '__ __ __',
    mask: '99 99 99',
    code: 508
  },
  PR: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  PS: {
    placeholder: '_ ___ ____',
    mask: '9 999 9999',
    code: 970
  },
  PT: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 351
  },
  PW: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 680
  },
  PY: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 595
  },
  QA: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 974
  },
  RE: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 262
  },
  RO: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 40
  },
  RS: {
    placeholder: '__ ______',
    mask: '99 999999',
    code: 381
  },
  RU: {
    placeholder: '___ ___-__-__',
    mask: '999 999-99-99',
    code: 7
  },
  RW: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 250
  },
  SA: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 966
  },
  SB: {
    placeholder: '_____',
    mask: '99999',
    code: 677
  },
  SC: {
    placeholder: '_ ___ ___',
    mask: '9 999 999',
    code: 248
  },
  SD: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 249
  },
  SE: {
    placeholder: '_ __ __ __',
    mask: '9 99 99 99',
    code: 46
  },
  SG: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 65
  },
  SH: {
    placeholder: '_____',
    mask: '99999',
    code: 290
  },
  SI: {
    placeholder: '_ ___ __ __',
    mask: '9 999 99 99',
    code: 386
  },
  SJ: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 47
  },
  SK: {
    placeholder: '_/___ ___ __',
    mask: '9999 999 99',
    code: 421
  },
  SL: {
    placeholder: '__ ______',
    mask: '99 999999',
    code: 232
  },
  SM: {
    placeholder: '____ ______',
    mask: '9999 999999',
    code: 378
  },
  SN: {
    placeholder: '__ ___ __ __',
    mask: '99 999 99 99',
    code: 221
  },
  SO: {
    placeholder: '_ ______',
    mask: '9 999999',
    code: 252
  },
  SR: {
    placeholder: '___-___',
    mask: '999-999',
    code: 597
  },
  SS: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 211
  },
  ST: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 239
  },
  SV: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 503
  },
  SX: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  SY: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 963
  },
  SZ: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 268
  },
  TC: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  TD: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 235
  },
  TG: {
    placeholder: '__ __ __ __',
    mask: '99 99 99 99',
    code: 228
  },
  TH: {
    placeholder: '_ ____ ____',
    mask: '9 9999 9999',
    code: 66
  },
  TJ: {
    placeholder: '___ __ ____',
    mask: '999 99 9999',
    code: 992
  },
  TK: {
    placeholder: '____',
    mask: '9999',
    code: 690
  },
  TL: {
    placeholder: '___ ____',
    mask: '999 9999',
    code: 670
  },
  TM: {
    placeholder: '__ __-__-__',
    mask: '99 99-99-99',
    code: 993
  },
  TN: {
    placeholder: '__ ___ ___',
    mask: '99 999 999',
    code: 216
  },
  TO: {
    placeholder: '__-___',
    mask: '99-999',
    code: 676
  },
  TR: {
    placeholder: '___ ___ __ __',
    mask: '999 999 99 99',
    code: 90
  },
  TT: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  TV: {
    placeholder: '__ ___',
    mask: '99 999',
    code: 688
  },
  TW: {
    placeholder: '_ ____ ____',
    mask: '9 9999 9999',
    code: 886
  },
  TZ: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 255
  },
  UA: {
    placeholder: '____ _____',
    mask: '9999 99999',
    code: 380
  },
  UG: {
    placeholder: '__ _______',
    mask: '99 9999999',
    code: 256
  },
  US: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  UY: {
    placeholder: '____ ____',
    mask: '9999 9999',
    code: 598
  },
  UZ: {
    placeholder: '__ ___ __ __',
    mask: '99 999 99 99',
    code: 998
  },
  VA: {
    placeholder: '__ ____ ____',
    mask: '99 9999 9999',
    code: 379
  },
  VC: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  VE: {
    placeholder: '___-_______',
    mask: '999-9999999',
    code: 58
  },
  VG: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  VI: {
    placeholder: '___-___-____',
    mask: '999-999-9999',
    code: 1
  },
  VN: {
    placeholder: '___ ____ ___',
    mask: '999 9999 999',
    code: 84
  },
  VU: {
    placeholder: '_____',
    mask: '99999',
    code: 678
  },
  WF: {
    placeholder: '__ __ __',
    mask: '99 99 99',
    code: 681
  },
  WS: {
    placeholder: '_____',
    mask: '99999',
    code: 685
  },
  YE: {
    placeholder: '_ ___ ___',
    mask: '9 999 999',
    code: 967
  },
  YT: {
    placeholder: '___ __ __ __',
    mask: '999 99 99 99',
    code: 262
  },
  ZA: {
    placeholder: '__ ___ ____',
    mask: '99 999 9999',
    code: 27
  },
  ZM: {
    placeholder: '___ ___ ___',
    mask: '999 999 999',
    code: 260
  },
  ZW: {
    placeholder: '__ _____',
    mask: '99 99999',
    code: 263
  }
};

export default countryData;
